module.exports = __webpack_public_path__ + "static/img/honor15.dc7a1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor15.png
// module id = OQqB
// module chunks = 0